/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "src/views/home/Home.react";
import Inspection from "src/views/inspection/Inspection.react";
import Report from "src/views/report/Report.react";
import Special from "src/views/report/Special.react";
import Progress from "src/views/progress/Progress.react";
import Photo from "src/views/photo/Photo.react";
import PrintResult from "src/views/print/Result.react";
import PrintInspection from "src/views/print/Inspection.react";
import Settings from "src/views/settings/Settings.react";
import Tools from "./views/inspection/Tools.react";

/**
 * Home
 * @returns
 */
export function HomePage() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/inspection" element={<Inspection />} />
        <Route path="/tools" element={<Tools />} />
        <Route path="/progress" element={<Progress />} />
        <Route path="/special" element={<Special />} />
        <Route path="/report" element={<Report />}>
          <Route path=":activeTab" element={<Report />} />
        </Route>
        <Route path="/photo" element={<Photo />} />
        <Route path="/print" element={<PrintInspection />} />
        <Route path="/print/result" element={<PrintResult />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
    </BrowserRouter>
  );
}
